import React from "react";
import { Radar } from "react-chartjs-2";

import Banner from "./../components/Banner";
import Cover from "./../components/Cover";
import SkillSet from "../components/SkillSet";
import ExperiencedTools from "../components/ExperiencedTools";
import YesNo from "../components/YesNo";
import Footer from "../components/Footer"

import { isMobile } from "../helpers/DevicesDetection";

import skillImage from "../assets/skillset.jpg";

import "./style.css"

// const CHART_TRIGGER_POSITION = 720
const SKILLS_TRIGGER_POSITION = 600

const SKILL_SET = [
  {
    title: "GO",
    score: 85,
    ico_class: ["golang-icon"],
    ico_size: "l"
  },
  {
    title: "JavaScript",
    score: 70,
    ico_class: ["fab fa-js"],
    ico_size: "l"
  },
  {
    title: "Python",
    score: 65,
    ico_class: ["fab fa-python"],
    ico_size: "l"
  },
  {
    title: "PHP",
    score: 65,
    ico_class: ["fab fa-php"],
    ico_size: "l"
  },
  {
    title: "Web Design",
    score: 80,
    ico_class: ["fab fa-html5", "fab fa-css3-alt"],
    ico_size: "m"
  },
  {
    title: "Graphic Design",
    score: 57,
    ico_class: ["fa fa-pencil-alt"],
    ico_size: "m"
  },
  {
    title: "Cook & Bake 😍",
    score: 85,
    ico_class: ["cooking-icon"],
    ico_size: "l"
  },
];

const CHART_DATA_INIT = {
  data: [5, 3.5, 4]
};

const SKILL_SET_DISCLAIMER = "The scales above just serve to compare or illustrate my degree of proficiency in certain skills."

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.isMobile = isMobile();
    this.wheelRate = 0;
    this.state = {
      elementsState: {
        isPreventScroll: true,
      },
      skills: {
        isTrigged: false,
        data: SKILL_SET.map(a => ({...a, score: 0})),
      },
      stackAndTools: [
        {
          title: "Web Stack",
          list: [
            "React",
            "Next.js",
            "Slim",
            "Flask",
            "Vue.js",
            "Bulma",
            "SCSS",
            "Bootstrap 3",
            "Codeigniter 3",
            "Laravel 5.2",
          ]
        },
        {
          title: "Operation",
          list: [
            "Docker",
            "Apache 2",
            "Nginx",
            "CircleCI",
            "DroneCI",
            "Sonarqube",
            "Kubernetes",
            "Firebase",
            "AWS"
          ]
        },
        {
          title: "Data Storage",
          list: [
            "MySQL",
            "Postgrest",
            "MongoDB",
            "Redis",
            "Elasticsearch",
            "RabbitMQ"
          ]
        }
      ],
      chart: {
        isTrigged: false,
        shouldRedraw: false,
        data: {
          labels: ["Passion", "Fast Learner", "Creativity"],
          datasets: [
            {
              label: "Strengths",
              data: [],
              pointRadius: [3, 3, 3],
              pointBorderWidth: [2, 2, 2],
              lineTension: 0.1,
              backgroundColor: ["rgba(30, 10, 20, 0.2)"],
              borderColor: ["rgba(30,10,20, 0.6)"],
              borderWidth: 2.5
            }
          ]
        },
        options: {
          title: {
            fontColor: "black",
            fontSize: "14",
            // lineHeight: 1,
            padding: 0,
            display: true,
            text: "Strengths",
            position: "bottom"
          },
          animation: {
            duration: 2000,
            easing: "easeOutCubic"
          },
          scale: {
            ticks: {
              stepSize: 1,
              beginAtZero: true,
              min: 1,
              max: 5
            }
          },
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function() {
                return "";
              }
            }
          }
        }
      }
    };
  }

  componentDidMount() {
    window.scrollTo(0,0);
    window.addEventListener("scroll", this.handleScroll);
    this.enbleScroll(5500);
  }

  transformBanner = (position) => {
    let bannerSection = document.getElementById("banner-wrapper")
    let bannerHeight = bannerSection.offsetHeight

    if (bannerHeight > position) {
      const ratio = {};
      ratio.percent = 100 - (position / bannerHeight) * 100;
      ratio.prob = ratio.percent / 100;
      ratio.probInv = ((position / bannerHeight) * 100) / 100;

      bannerSection.style.transform = `scale(${ratio.prob + ratio.probInv * 0.6})`
      bannerSection.style.opacity = ratio.prob + ratio.probInv * 0.3
    }
  }

  triggerSkillAnimate = () => {
    this.setState({ skills: {
        data: SKILL_SET,
        isTrigged: true,
      }
    });
  }

  triggerRadarChartAnimate = () => {
    const newChart = { ...this.state.chart };
    newChart.shouldRedraw = true;
    newChart.data.datasets[0].data = CHART_DATA_INIT.data;
    newChart.isTrigged = true
    this.setState({ chart: { ...newChart } });
  }

  handleScroll = event => {
    let position = window.scrollY
    let radarChartElm = document.getElementById("strengths")
    let chartTriggerPos = radarChartElm.offsetTop

    this.transformBanner(position)
    if (position >= SKILLS_TRIGGER_POSITION && !this.state.skills.isTrigged) {
      this.triggerSkillAnimate()
    }
    if (position >= chartTriggerPos && !this.state.chart.isTrigged) {
      this.triggerRadarChartAnimate()
    }
  };

  attachSmoothScrollToArrowBtn = () => {
    document.querySelector('a[href="#coverSection"]').addEventListener("click", (e) => {
      e.preventDefault();
      let targetElm = document.getElementById("coverSection")
      window.scrollTo({top: targetElm.offsetTop, behavior: 'smooth'});
    })
  }

  enbleScroll(enbleDelayTime) {
    setTimeout(() => {
      this.setState({elementsState: {...this.state.elementsState, isPreventScroll: false}})
      this.attachSmoothScrollToArrowBtn()
    }, enbleDelayTime);
  }

  render() {
    return (
      <div className={`${this.state.elementsState.isPreventScroll? 'prevent-scroll': ''}`}>
        <div id="banner-wrapper">
          <Banner />
        </div>
        <div id="contentSection">
          <Cover id="coverSection" />
          <section className="section">
            <div className="container">
              <div className="body-content">
                <div className="head has-text-centered">
                  <h1 className="title is-3">Skills</h1>
                  <hr />
                </div>
                <div className="columns">
                  <div className="column is-half paddingless-y">
                    <div id="skills">
                      {
                        this.state.skills.data.map((skill, idx) => {
                          return (
                            <SkillSet
                              key={idx}
                              skillName={skill.title}
                              icons={skill.ico_class}
                              iconSize={skill.ico_size}
                              skillScore={skill.score}
                            />
                          )
                        })
                      }
                    </div>
                  </div>
                  <div className="column is-half">
                    <div id="strengths">
                      <Radar
                        data={this.state.chart.data}
                        options={this.state.chart.options}
                        redraw={this.state.chart.shouldRedraw}
                        width={200}
                        height={130}
                      />
                    </div>
                  </div>
                </div>
                <div className={"disclaimer"}>*{SKILL_SET_DISCLAIMER}</div>
              </div>
              <div className="body-content">
                <div className="head has-text-centered">
                  <h1 className="title is-3">Experienced Tools</h1>
                  <hr />
                </div>

                <div className="columns">
                  <div className="column">
                    <img src={skillImage} alt="" />
                  </div>
                  <div className="column">
                    <div className="columns">
                      {this.state.stackAndTools.map((tool, index) => {
                        return (
                          <div className="column" key={index}>
                            <ExperiencedTools tools={tool} />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="body-content">
                <div className="columns">
                  <div className="column is-half is-offset-one-quarter">
                    <div className="head has-text-centered">
                      <h1 className="title is-3" id="orbit">
                        ?
                      </h1>
                      <hr />
                    </div>
                    <YesNo />
                  </div>
                </div>
              </div>
            </div>
          </section>
          <Footer/>
        </div>
      </div>
    );
  }
}
